/**
 * WordPress environment variables.
 */
export default {
  imagesPath: "/wp-content/themes/renascare/images",
  searchPageUri: "/?s=",
};
